module.exports = __webpack_public_path__ + "img/leggings.fcd8b102.svg";